const setLegendSwitchSelection = (legendSelection) => {
  return {
    type: 'SET_LEGEND_SWITCH_SELECTION',
    payload: legendSelection,
  }
}

export {
  setLegendSwitchSelection,
}